<template>
  <TemplateProductModel v-bind="data" />
</template>

<script setup>
// Layout
definePageMeta({
  layout: 'default',
})

// i18n
defineI18nRoute({
  paths: {
    de: '/virtuelle-event-software',
    en: '/virtual-event-software',
    fr: '/logiciel-evenements-virtuels',
    es: '/herramienta-eventos-virtuales',
  },
})

// Composables
const { locale } = useI18n()
const { setAvailableLanguages } = useAvailableLanguages()
const { state } = useConditionalPreviewMode()
const localePath = useLocalePath()
const { $md } = useMarkdown()
const { public: publicRuntimeConfig } = useRuntimeConfig()

// Async Data
const { data } = await useFetch(`/api/content/pages/products/${locale.value}`, {
  key: `page-products-virtual-event-software-${locale.value}`,
  query: {
    preview: state.preview,
  },
  transform: (input) => {
    const { allProductPages, ...props } = input
    return {
      ...props,
      page: allProductPages.find(({ slug }) => slug === 'virtual-event-software'),
    }
  },
})

// Meta
const head = useLocaleHead({
  identifierAttribute: 'id',
  addSeoAttributes: true,
})

useSeoMeta({
  title: data.value.page.seoTitle,
  description: data.value.page.seoDescription,
  ogTitle: data.value.page.seoTitle,
  ogDescription: data.value.page.seoDescription,
  twitterTitle: data.value.page.seoTitle,
  twitterDescription: data.value.page.seoDescription,
})

useHead({
  link: head.value.link,
  meta: head.value.meta,
  script: [
    {
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        'mainEntity': data.value.page.faq.map(item => ({
          '@type': 'Question',
          'name': item.title,
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': $md.render(item.text),
          },
        })),
      }),
      type: 'application/ld+json',
    },
    {
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        'itemListElement': [
          {
            '@type': 'ListItem',
            'position': 1,
            'name': data.value.home.trackingBreadcrumbTitle,
            'item': `${publicRuntimeConfig.baseUrl}${localePath('index')}`,
          },
          {
            '@type': 'ListItem',
            'position': 2,
            'name': data.value.page.trackingBreadcrumbTitle,
          },
        ],
      }),
      type: 'application/ld+json',
    },
  ],
})

onMounted(() => {
  setAvailableLanguages()
})
</script>
